module.exports = __webpack_public_path__ + "img/usa-logo.8bbaf04f.jpg";